var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"fixed-bottom",attrs:{"sticky-bottom":""}},[_c('b-row',[_c('b-col',{staticClass:"text-center border-top border-success bg-light small shadow",attrs:{"md":"12"}},[_vm._v(" Copyright© "),_c('strong',[_vm._v("ADRs")]),_vm._v(" Systems ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }